import { render, staticRenderFns } from "./SendCredentials.vue?vue&type=template&id=5efaccdc&scoped=true"
import script from "./SendCredentials.vue?vue&type=script&lang=js"
export * from "./SendCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efaccdc",
  null
  
)

export default component.exports